module.exports = __webpack_public_path__ + "static/media/viiew_05_Budhha_New.c7bec567.jpg";